export default "https://cdn-static.gokick.com/assets/f9e57853bbf9ca449046a7aa5fdd940e337957cb/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";